import locationRepository from "../repositories/LocationRepository";
import { buildSearchParams } from "../utils/requestHelpers";

export class LocationService {
  static GetLocation(instance, locationId) {
    const repo = new locationRepository;
    const params = buildSearchParams(
      {
        locationId: locationId
      }
    );

    return repo.getLocation(instance, params);
  }

  static FindCities(instance, searchParams) {
    const repo = new locationRepository;
    const params = buildSearchParams(searchParams); 

    return repo.findCities(instance, params).then();
  }

  static UpdateCity(instance, payload) {
    const repo = new locationRepository;

    return repo.updateCity(instance, payload).then();
  }

  static FindStates(instance, searchParams) {
    const repo = new locationRepository;
    const params = buildSearchParams(searchParams); 

    return repo.findStates(instance, params).then();
  }
}